import React from 'react';
import CheckedIcon from '../../../images/icons/checked-icon.svg';
import CheckedIconError from '../../../images/icons/checked-error-icon.svg';
import UserInviteStatus from '../../../images/icons/user-invite-config-icon.svg';
import { Typography } from '@material-ui/core';
import useStyles from './styles';

const CardHistorico = (props) => {

  const classes = useStyles();
  const { dados } = props;

  const { acaoUsuario, nomeUsuarioAuditor, nomeUsuario, sobrenomeUsuario, data } = dados;

  let icon;
  switch (acaoUsuario) {
    case 'Aceitou':
      icon = CheckedIcon;
      break;
    case 'Recusou':
      icon = CheckedIconError;
      break;
    case 'Convidou':
      icon = UserInviteStatus;
      break;
    default:
      break;
  }

  return (
    <div className={classes.card}>
      <img src={icon} />
      <div style={{ marginLeft: 10 }}>
        <Typography className={classes.text}>
          <strong>{nomeUsuarioAuditor}</strong> {acaoUsuario.toLowerCase()} <b>colaborador(a) {nomeUsuario} {sobrenomeUsuario}</b>
        </Typography>
        <Typography className={classes.date}>{data}</Typography>
      </div>
    </div>
  );
}

export default CardHistorico;
